import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import UuidPlugin from "./utils/uuid";
import { checkUserLogin } from "./utils/api";
import "./assets/css/markdown-h.scss";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(UuidPlugin);
Vue.prototype.$staticBaseUrl = process.env.VUE_APP_STATIC_BASE_URL;
if (typeof window !== "undefined") {
  window.process = window.process || {};
  window.process.env = window.process.env || {};
  window.process.env.VUE_APP_STATIC_BASE_URL = process.env.VUE_APP_STATIC_BASE_URL;
  Vue.prototype.process = window.process;
}

// 将登录检查方法添加到Vue原型中，以便在组件中直接使用
Vue.prototype.$checkLogin = async function() {
  try {
    const isLoggedIn = await checkUserLogin();
    return isLoggedIn === true;
  } catch (error) {
    console.error('检查登录状态时发生错误：', error);
    return false;
  }
};

// 百度密钥
Vue.prototype.baiduKey = 'e5b4b59c67f19e083342e2bd495d1aae'

// 全局过滤器：截断字符串并添加省略号
Vue.filter("truncate", function (text, length = 3) {
  if (text && text.length > length) {
    return text.substring(0, length) + "...";
  } else {
    return text;
  }
});

// 设置全局错误处理器
// Vue.config.errorHandler = function (err, vm, info) {
//   // 这里可以将错误信息发送到服务器或记录到日志文件
//   console.info('Error:', err);
//   console.info('VM instance:', vm);
//   console.info('Info:', info);
// };

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
